import { render, staticRenderFns } from "./search-components.vue?vue&type=template&id=278e57d3&scoped=true&"
import script from "./search-components.vue?vue&type=script&lang=js&"
export * from "./search-components.vue?vue&type=script&lang=js&"
import style0 from "./search-components.vue?vue&type=style&index=0&id=278e57d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278e57d3",
  null
  
)

export default component.exports